import React, { FC } from 'react'

import { isInvalidRequired, isMissingRequired } from '../../../../../helpers/requiredFields'

import { IProfileReqField, IReqFieldType } from './ProfileFields'
import { IHorseData } from '../../../../../models/horse/horse.interface'

interface RequiredFieldErrorProps {
  setType: (type: IReqFieldType) => void
  field: IProfileReqField
  editHandler?: (data: IProfileReqField, horse?: IHorseData) => void
  horse?: IHorseData
}
export const RequiredFieldError: FC<RequiredFieldErrorProps> = ({
  setType,
  field,
  editHandler,
  horse,
}) => {
  const onEdit = (current: IReqFieldType) => {
    if (current === 'tel' || current === 'text' || current === 'date' || current === 'select') {
      setType(current)
    } else {
      if (editHandler) editHandler(field, horse)
    }
  }

  return (
    <div className="flex gap-2">
      <span>
        {isMissingRequired(field)
          ? 'Missing'
          : field.isExpired
            ? 'Expired'
            : isInvalidRequired(field) && 'Invalid'}
      </span>
      <span>•</span>
      <button onClick={() => onEdit(field.type)} className="underline hover:no-underline">
        Edit
      </button>
    </div>
  )
}
